import { forwardRef, InputHTMLAttributes } from 'react';

import { MagnifierOutlinedSize16, MagnifierOutlinedSize24 } from '@hh.ru/magritte-ui-icon/icon';
import { BaseInput } from '@hh.ru/magritte-ui-input/BaseInput';
import { ControlledSearchInputProps } from '@hh.ru/magritte-ui-input/types';

export const SearchInput = forwardRef<
    HTMLInputElement,
    ControlledSearchInputProps & Omit<InputHTMLAttributes<HTMLInputElement>, keyof ControlledSearchInputProps>
>(({ size, ...props }, ref) => {
    return (
        <BaseInput
            {...props}
            elevatePlaceholder={false}
            inputIcon={size === 'small' ? MagnifierOutlinedSize16 : MagnifierOutlinedSize24}
            ref={ref}
            size={size}
        />
    );
});

SearchInput.displayName = 'SearchInput';
